// Decide where a user lands right after login / onboarding.
// A "simple client" (end-user: client_type endUser, not admin, not distributor)
// goes to the simplified client shell (/me). Everyone else keeps the existing
// behaviour (/dashboard). The is_simple_client flag is computed by the backend
// (auth#getUserDetailsIntern and auth#loginWithToken). Login itself is unchanged —
// only the redirect target depends on this flag.
export function landingPathForUser(user) {
  return (user && user.is_simple_client) ? '/me' : '/dashboard'
}
